import Vue from 'vue'
import Router from 'vue-router'
import index from '../pages/index/index'
import company from "../pages/company/company";
import contact from "../pages/contact/contact";
import newsDetail from "../pages/newsDetail/newsDetail";
// import productService from '../components/productService/productService'
// import projectCase from '../components/projectCase/projectCase'
// import about from '../components/about/about'
// import news from '../components/news/news'
import product from "../pages/product/product";
import cases from "../pages/case/case";
import partner from "../pages/partner/partner";
import newsPage from "../pages/newsPage/newsPage";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/company',
      name: 'company',
      component: company

    },
    {
      path: '/contact',
      name: 'contact',
      component: contact

    },
    // {
    //   path: '/contact',
    //   name: 'contact',
    //   component: contact
    //
    // },
    {
      path: '/product',
      name: 'product',
      component: product

    },
    {
      path: '/case',
      name: 'case',
      component: cases
    },
    {
      path: '/partner',
      name: 'partner',
      component: partner
    },


    // {
    //   path: '/news',
    //   name: 'news',
    //   component: news
    // },
    {
      path: '/newsDetail/:id',
      name: 'newsDetail',
      component: newsDetail
    },
    {
      path: '/newsPage',
      name: 'newsPage',
      component: newsPage
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js